import { useEffect, useRef, useState } from 'react';
import { morceauxDuParagraphe, SUJETS_DE_L_AIDE } from './aideDuTelephone';
import { DessinDuGeste } from './DessinDuGeste';
import { C_EST_COMPRIS, PRECEDENT, rangSurTotal, SUIVANT } from '../partage/vocabulaire';
import './AideAuPouce.css';

/**
 * L'Aide du téléphone (ticket 14 de telephone, maquette validée le 2026-09-28, forme 2 « un
 * geste à la fois » ; textes revus au ticket 08 du chantier `aide`, puis au ticket 05 du
 * chantier `telephone-cadre`, au ticket 07 de `telephone-journee-agenda` et au ticket 06 de
 * `telephone-projets-fiche`) : les sujets à la suite (dix-neuf, comptés dans les données), un par
 * écran, avec « Précédent » et « Suivant », et « C'est compris » au dernier, qui
 * ramène aux Paramètres. Rien à faire pour de vrai : on regarde le geste, on lit, on passe.
 * Elle rouvre toujours au premier sujet.
 */
export function AideAuPouce({ onCompris }: { onCompris: () => void }) {
  const [rang, setRang] = useState(0);
  const haut = useRef<HTMLDivElement>(null);
  const premierRendu = useRef(true);
  const total = SUJETS_DE_L_AIDE.length;
  const sujet = SUJETS_DE_L_AIDE[rang] ?? SUJETS_DE_L_AIDE[0]!;
  const dernier = rang === total - 1;

  // Un nouveau sujet se lit depuis son haut, comme un nouvel écran.
  useEffect(() => {
    if (premierRendu.current) {
      premierRendu.current = false;
      return;
    }
    haut.current?.scrollIntoView({ block: 'start', behavior: 'instant' });
  }, [rang]);

  return (
    <div className="aide-tel" ref={haut}>
      <p className="aide-tel-rang">{rangSurTotal(rang + 1, total)}</p>
      <DessinDuGeste scene={sujet.scene} />
      <div className="aide-tel-texte">
        <span className="aide-tel-geste">{sujet.geste}</span>
        <h1 className="aide-tel-titre">{sujet.titre}</h1>
        {sujet.paragraphes.map((paragraphe) => (
          <p key={paragraphe}>
            {morceauxDuParagraphe(paragraphe).map((m, i) => (m.gras ? <b key={i}>{m.texte}</b> : m.texte))}
          </p>
        ))}
      </div>
      <div className="aide-tel-pied">
        {rang > 0 && (
          <button type="button" className="aide-tel-bouton aide-tel-bouton--doux" onClick={() => setRang(rang - 1)}>
            {PRECEDENT}
          </button>
        )}
        {dernier ? (
          <button type="button" className="aide-tel-bouton" onClick={onCompris}>
            {C_EST_COMPRIS}
          </button>
        ) : (
          <button type="button" className="aide-tel-bouton" onClick={() => setRang(rang + 1)}>
            {SUIVANT}
          </button>
        )}
      </div>
      <div className="aide-tel-points" aria-hidden="true">
        {SUJETS_DE_L_AIDE.map((s, i) => (
          <i key={s.titre} className={i === rang ? 'aide-tel-point aide-tel-point--ici' : 'aide-tel-point'} />
        ))}
      </div>
    </div>
  );
}
